import { useEffect, useMemo, useState } from 'react';
import CommonProgressBar from '../../component/common/Input/CommonProgressBar';
import DonutChartCard from '../../component/common/cards/DonutChartCard';
import PropTypes from 'prop-types';
import { use } from 'react';

const KidsDashboardSection6 = ({ audioStats, storyStats }) => {
  const [mostPopularStory, setMostPopularStory] = useState('');
  const [mostPopularAudio, setMostPopularAudio] = useState('');

  // const chartData = [
  //   {
  //     label: 'Audio',
  //     value: audioStats?.length,
  //     percentage: ((audioStats?.length / (storyStats?.length + audioStats?.length)) * 100).toFixed(
  //       0
  //     ),
  //     color: '#F05289'
  //   },
  //   {
  //     label: 'Stories',
  //     value: storyStats?.length,
  //     percentage: ((storyStats?.length / (storyStats?.length + audioStats?.length)) * 100).toFixed(
  //       0
  //     ),
  //     color: '#FF9BCB'
  //   }
  // ];
  const audioPer = useMemo(() => {
    if (!audioStats?.summary?.totalActivityKids) {
      return 0;
    }
    return (
      (audioStats?.summary?.totalActivityKids / audioStats?.summary?.totalKids) *
      100
    ).toFixed(0);
  }, [audioStats?.summary]);
  const chartData = useMemo(() => {
    if (!audioStats?.activityByType || audioStats.activityByType.length === 0) {
      return [];
    }

    // Filter out null _id entries and calculate totals
    const validActivities = audioStats.activityByType.filter((item) => item._id !== null);
    const totalActivities = validActivities.reduce((sum, item) => sum + item.totalActivities, 0);

    // Define colors for different activity types
    const colorMap = {
      lullabies: '#F05289',
      audio_stories: '#FF9BCB',
      relax: '#A9A9A9',
      breathe: '#06B6D4',
      calm: '#10B981',
      meditation: '#F59E0B',
      sleep: '#AAAAAA'
    };

    // Generate chart data
    return validActivities
      .map((item, index) => {
        const percentage =
          totalActivities > 0 ? ((item.totalActivities / totalActivities) * 100).toFixed(1) : '0';

        return {
          label: item._id.charAt(0).toUpperCase() + item._id.slice(1).replace('_', ' '), // Capitalize and format label
          value: item.totalActivities,
          totalReads: item.totalReads,
          totalPlays: item.totalPlays,
          percentage: parseFloat(percentage),
          color: colorMap[item._id] || `hsl(${(index * 137.5) % 360}, 70%, 60%)` // Fallback color
        };
      })
      .sort((a, b) => b.value - a.value); // Sort by activity count descending
  }, [audioStats?.activityByType]);

  return (
    <div className="border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl md:p-6 p-4 dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder dark:text-shoorah-darkBg bg-white mt-5">
      <div className="text-lg md:text-xl font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
        Audio and Stories
      </div>
      <div className="text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg font-[400]">
        This stats boxes will show you the user activity status like story and Mindfullness.
      </div>
      <div className="flex flex-col sm:flex-row gap-4 2xl:gap-6 md:mt-6 mt-4 sm:w-full overflow-x-auto horizontal-card-scrollbar md:pb-4">
        <div className="min-h-[200px] sm:min-h-full sm:w-[187px] 2xl:w-full sm:max-w-[300px] md:p-6 p-4 flex flex-col justify-between min-w-[187px] bg-[#FFFFFF] rounded-2xl border border-[#E7E8EA] dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder">
          <div className="text-xl font-medium leading-[22px] text-shoorah-textBlack">
            Most Popular Story
          </div>
          <div className="lg:text-[48px] text-[48px] lg:leading-[80px] leading-[60px] font-semibold text-shoorah-textBlack">
            {audioStats?.mostReadStories?.[0]?.title}
          </div>
        </div>
        <div className="flex flex-col md:gap-[27px] gap-4 w-full sm:min-w-[333px]">
          <div className="md:px-5 md:py-6 p-4 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder border border-[#E7E8EA] rounded-xl h-[175px] bg-shoorah-white">
            <div className="text-xl font-medium leading-[22px] text-shoorah-textBlack mb-[22px]">
              Most Popular Mindfullness
            </div>
            <div className="text-[48px] leading-[36px] font-semibold text-shoorah-textBlack mb-[18px]">
              <span className="text-[30px] leading-[36px] font-semibold italic">
                {audioStats?.mostReadPods?.[0]?.title}
              </span>
            </div>
            <div className="flex items-center justify-between w-full">
              <div className="text-xs leading-5 text-[#8FD460]">
                +{audioStats?.mostReadPods?.[0]?.readCount}
              </div>
              <div className="text-[rgba(41,45,50,0.38)] text-xs leading-5">Last 7 days</div>
            </div>
          </div>
          <div className="md:px-5 md:py-6 p-4 bg-[#ffffff] dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder border border-[#E7E8EA] rounded-xl">
            <div className="flex items-center justify-between mb-[30px]">
              <div className="text-xl leading-[22px] font-medium text-shoorah-textBlack">
                Media Accessed By
              </div>
              <div className="text-[18px] leading-[21px] font-medium text-[#67A14A]">
                {/* {resultData?.completionRate ? resultData?.completionRate : '0%'} */}
                {audioPer}%
              </div>
            </div>
            <div>
              <CommonProgressBar
                percentage={
                  // resultData?.completionRate?.split('%')[0]
                  //     ? resultData?.completionRate?.split('%')[0]
                  audioPer
                }
                barColor={'#000'}
                bgColor={'#898b8f'}
              />
            </div>
          </div>
        </div>
        <div className="w-full lg:max-w-[264px] 2xl:max-w-[300px]">
          <DonutChartCard
            data={chartData}
            title={'Heard By People'}
            labelClassName={'w-full'}
            className={
              'dark:!bg-shoorah-darkBgColor dark:!border-none flex flex-col justify-between lg:w-full h-full'
            }
          />
        </div>
      </div>
    </div>
  );
};

KidsDashboardSection6.propTypes = {
  audioStats: PropTypes.any,
  storyStats: PropTypes.any
};

export default KidsDashboardSection6;
